import { alpha, Theme } from '@mui/material/styles';

import { getAppTokens, getLibraryTokens, libraryChromePalette } from '@mightyhive/theme';

export interface LibraryPageTokens {
  pageGradient: string;
  pageGradientFallback: string;
  pageHeadingColor: string;
  pageSubtitleColor: string;
  bodySecondaryColor: string;
  filterLabelColor: string;
  primaryButtonBg: string;
  primaryButtonHoverBg: string;
  primaryButtonColor: string;
  filterPillActiveBg: string;
  filterPillActiveColor: string;
  filterPillInactiveBg: string;
  filterPillInactiveColor: string;
  filterPillCountOpacity: number;
  cardBackground: string;
  cardBorder: string;
  cardHoverBackground: string;
  tagChipBg: string;
  tagChipColor: string;
  toolbarFieldBg: string;
  statusTextColor: string;
  sectionSurfaceBg: string;
  sectionSurfaceBorder: string;
  breadcrumbColor: string;
  breadcrumbActiveColor: string;
  tabActiveBg: string;
  tabActiveColor: string;
  tabInactiveBg: string;
  tabInactiveColor: string;
}

export const getLibraryPageTokens = (theme: Theme): LibraryPageTokens => {
  const appTokens = getAppTokens(theme);
  const libraryTokens = getLibraryTokens(theme);

  return {
    pageGradient: appTokens.pageGradient,
    pageGradientFallback: appTokens.pageGradientFallback,
    pageHeadingColor: appTokens.pageHeadingColor,
    pageSubtitleColor: appTokens.pageSubtitleColor,
    bodySecondaryColor: appTokens.bodySecondaryColor,
    filterLabelColor: appTokens.filterLabelColor,
    primaryButtonBg: appTokens.primaryButtonBg,
    primaryButtonHoverBg: appTokens.primaryButtonHoverBg,
    primaryButtonColor: appTokens.primaryButtonColor,
    filterPillActiveBg: libraryTokens.tabActiveBg,
    filterPillActiveColor: libraryTokens.tabActiveColor,
    filterPillInactiveBg: libraryTokens.tabInactiveBg,
    filterPillInactiveColor: libraryTokens.tabInactiveColor,
    filterPillCountOpacity: 0.7,
    cardBackground: alpha(theme.palette.common.white, libraryChromePalette.cardBackgroundOpacity),
    cardBorder: alpha(theme.palette.common.white, libraryChromePalette.cardBorderOpacity),
    cardHoverBackground: alpha(
      theme.palette.common.white,
      libraryChromePalette.cardHoverBackgroundOpacity,
    ),
    tagChipBg: alpha(theme.palette.grey[100], libraryChromePalette.tagChipBgOpacity),
    tagChipColor: appTokens.filterLabelColor,
    toolbarFieldBg: libraryChromePalette.toolbarFieldBg,
    statusTextColor: appTokens.pageSubtitleColor,
    sectionSurfaceBg: libraryTokens.sectionSurfaceBg,
    sectionSurfaceBorder: libraryTokens.sectionBorder,
    breadcrumbColor: libraryTokens.breadcrumbColor,
    breadcrumbActiveColor: libraryTokens.breadcrumbActiveColor,
    tabActiveBg: libraryTokens.tabActiveBg,
    tabActiveColor: libraryTokens.tabActiveColor,
    tabInactiveBg: libraryTokens.tabInactiveBg,
    tabInactiveColor: libraryTokens.tabInactiveColor,
  };
};
